<template>
    <section class="chart-container">
        <!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters"  size="mini">
                <el-form-item label="项目">
					<el-select v-model="filters.projectId"   @change="getDevices" style="width:250px" filterable>
						<el-option
							v-for="item in projects"
							:label="item.name"
							:value="item.projectId" :key="item.projectId">
						</el-option>
					</el-select>
				</el-form-item>
                <el-form-item label="点位名称" >
					<el-select v-model="filters.mn"  multiple collapse-tags  @change="getFactorsByMn"  style="width:320px" filterable reserve-keyword>
                        <el-option value="-1" label="全选"></el-option>
                        <el-option value="-2" label="取消全选"></el-option>
						<el-option
							v-for="item in devices"
							:label="item.name"
							:value="item.mnCode" :key="item.mnCode">
						</el-option>
					</el-select>
				</el-form-item>
                <el-form-item label="设备编码"  v-if="type==0">
					<el-select v-model="filters.mn"  multiple collapse-tags  @change="getFactorsByMn"   style="width:320px" filterable reserve-keyword>
                        <el-option value="-1" label="全选"></el-option>
                        <el-option value="-2" label="取消全选"></el-option>
						<el-option
							v-for="item in devices"
							:label="item.mnCode"
							:value="item.mnCode" :key="item.mnCode">
						</el-option>
					</el-select>
				</el-form-item>
             	<el-form-item label="选择日期">
                    <el-date-picker  v-model="filters.time"  type="daterange"   value-format="yyyy-MM-dd"> </el-date-picker>
                </el-form-item>
				<el-form-item>
                    <my-button  @select-type="clickBtn" QueryButtonShow ExportButtonShow></my-button>
				</el-form-item>
			</el-form>
		</el-col>

        <el-table :data="dataList" border highlight-current-row v-loading="listLoading" style="width: 100%;" :height="formHeight"   size="small" >
			<el-table-column type="index" label="序号"   min-width="60"></el-table-column>
            <el-table-column prop="name" label="点位名称"   sortable></el-table-column>
			<el-table-column prop="mn" label="设备编码"    v-if="type==0"></el-table-column>
			<el-table-column prop="time" label="监测时间"   sortable> </el-table-column>
            <el-table-column prop="dar" label="采集率(%)"  ></el-table-column>
		</el-table>
    </section>
</template>

<script>
    import * as echarts from "echarts";
    import {getProjects,getDevicesByProjectId,getDataCollectionRate} from '../../api/api';
    import {formatDateDay,in_array} from '../../../static/fun.js';

    import myButton from '../../components/myButton/index.vue'

	export default {
		components: { myButton },
        data() {
            return {
                filters: {
                    mn: '',
                    projectId:'',
                    time:[]
                },
                projects:[],
                devices:[],
                dataList:[],
                listLoading:false,
                firstFlag:true,
                formHeight:0,

                type:sessionStorage.getItem("type"),
                userId:sessionStorage.getItem('userId'),
                deviceMap:new Map()
            }
        },
        methods: {
            clickBtn(type){
				if(type=="query"){
					this.getDataList();
				}else if(type=="export"){
					this.exportData();
				}
			},
              //获取选中设备可监测的因子
              getFactorsByMn(){
                if(this.filters.mn.toString()==""){
                    return;
                }
                if(in_array('-2',this.filters.mn)){
                    this.filters.mn=[];
                    return;
                }
                if(in_array('-1',this.filters.mn)){
                    this.filters.mn=[];
                    this.devices.forEach(element => {
                        this.filters.mn.push(element.mnCode);
                    });
                }
            },
            //查询项目信息
			getProjects() {
				this.listLoading = true;
				getProjects().then((res) => {
                    this.projects = res.data.data;
                    this.listLoading = false;
			        if(this.projects.length>0){
                        this.filters.projectId=this.projects[0].projectId;
						this.getDevices();
					}
				});
			},
            //获取趋势分析数据
            getDataList(){
                let para = {
                    mn: this.filters.mn.toString(),
                    projectId: this.filters.projectId,
                    userId:this.userId,
					startDate: this.filters.time[0],
					endDate: this.filters.time[1]
                };
                this.listLoading = true;
                
				getDataCollectionRate(para).then((res) => {
                    this.listLoading = false;
                    if(res.data.result=="true"||res.data.result==true){
                        this.dataList = res.data.datas; 
                        for (let index = 0; index < this.dataList.length; index++) {
                            const element = this.dataList[index];
                            element.name=this.deviceMap.get(element.mn);
                        }
                    }else{
                        this.$message({
                            message: "查询失败，请重试",
                            type: 'error'
                        })
                    }
				});
            },
            //获取设备列表
			getDevices() {
                 if(this.filters.projectId==""){
                    return;
                }
                this.listLoading = true;
                let para = {
                    projectId: this.filters.projectId
                };
				getDevicesByProjectId(para).then((res) => {
                    this.listLoading = false;
                    
                    this.devices = res.data.data;
                    this.filters.mn=[];
                    if( this.devices.length>0){
                        this.devices.forEach(element => {
                            this.deviceMap.set(element.mnCode,element.name);
                        });
                    }
                    if(this.firstFlag){
                        this.getDataList();
                        this.firstFlag=false;
                    }
				});
            },
            exportData(){
                require.ensure([], () => {
                    const { export_json_to_excel } = require('vendor/Export2Excel');
                    const tHeader =  ['点位名称','设备编码', '监测时间', '采集率' ];
                    const filterVal = ['name', 'mn', 'time', 'dar'];  

                    var data=[];
                    var sheetName=[];
                    data.push(this.formatJson(filterVal, this.dataList));
                    sheetName.push('Sheet1');

                    export_json_to_excel(tHeader, data, '采集率统计',sheetName);
                }) 
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },
            SetHeight:function(){
				var hgt=document.getElementsByClassName('content-container')[0].clientHeight;
				var titleHgt=document.getElementsByClassName('tags-view-wrapper')[0].clientHeight;
				var toolbarHgt=document.getElementsByClassName('toolbar')[0].clientHeight;
                this.formHeight=hgt-titleHgt-toolbarHgt-120;
			},
			setTime(){
				var start = new Date();
                start.setDate(start.getDate()-1);
                var time=formatDateDay(start);
                this.filters.time.push(time);
				this.filters.time.push(time);
				this.getProjects();
			}
        },
        mounted: function () {
            var _this=this;
			var timer=null;
			clearInterval(timer);
			timer =setInterval(function(){
				if(_this.formHeight ==0){
					_this.SetHeight();
				}else{
					clearInterval(timer);
				}
            },10)
            this.setTime();
        }
    }
</script>

<style scoped>
    .el-col-1{
        text-align: center;
    }
    .dataTab{
		margin: 10px;
		margin-top: 0;
		cursor: pointer;
		color: #409eff;
		background: #d9edf7;
	}
    .tabSelect{
		color: #fff;
		background: #409eff;
	}
</style>



// WEBPACK FOOTER //
// DataCollectionRate.vue?4d282542